import { Component, Inject, SecurityContext } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgIf, DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { AboutModalConfig } from '../../interfaces/about-modal-config';

@Component({
  selector: 'app-about-modal',
  templateUrl: './about-modal.component.html',
  styleUrls: ['./about-modal.component.scss'],
  imports: [MatDialogTitle, MatIcon, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, DatePipe, TranslateModule]
})
export class AboutModalComponent {
  public pdfUrl: SafeResourceUrl | null;
  public isOpenUrl = false;
  public constructor(
    public dialogRef: MatDialogRef<AboutModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AboutModalConfig,
    private sanitizer: DomSanitizer
  ) { }

  public openCookieModal(name: string) {
    switch (name) {
      case 'privacy': {
        const url = this.sanitizer.sanitize(
          SecurityContext.URL,
          'https://osc3b2cpolicies.blob.core.windows.net/documents/US/20200729/OSC-Privacy-Notice_English.pdf'
        );
        this.pdfUrl = window.open(url, '_blank');
        break;
      }
      case 'terms': {
        const url = this.sanitizer.sanitize(
          SecurityContext.URL,
          'https://osc3b2cpolicies.blob.core.windows.net/documents/US/20200729/OSC-Terms-of-Service_English.pdf'
        );
        this.pdfUrl = window.open(url, '_blank');
        break;
      }
      case 'cookie': {
        const url = this.sanitizer.sanitize(
          SecurityContext.URL,
          'https://osc3b2cpolicies.blob.core.windows.net/documents/US/20200729/OSC-Cookie-Notice_English.pdf'
        );
        this.pdfUrl = window.open(url, '_blank');
        break;
      }
    }
  }
}
